import makeRequest from './makeRequest';
import environment from '../environment';

/**
 * Pause a subscription.
 * @param {Object} payload - The payload for the pause subscription request.
 * @param {string} payload.simplrAccountId - The ID of the Simplr account.
 * @param {string} payload.subscriptionId - The ID of the subscription.
 * @param {number} payload.pauseIncrement - The increment for the pause duration.
 * @param {string} payload.incrementType - The type of increment (e.g., days, months).
 * @param {string} payload.customerEmail - The email address of the customer.
 * @param {number} payload.orderId - The ID of the order related to the subscription.
 * @returns {Promise<Object>} - A promise that resolves to the response from the pause subscription API.
 */
export const pauseSubscription = async (payload) => {
  return await makeRequest(`${environment.eCommerce.SUBSCRIPTIONS_BASE_URL}/pause`, {
    method: 'post',
    data: payload,
  });
};
